// regnskapsforer-nav-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'r1n.denied.title': 'The firm workspace is only for the accounting firm\'s members',
  'r1n.denied.body': 'Clients work in their own business workspace and cannot open the firm\'s client overview, reconciliation or control.',
  'r1n.denied.exit': 'To my accounts',
});
